export const FEATURE_NAME = '@zerops/zerops/feature/object-storages-usage';
